pdfHandler = {
    $html : $('html'),
         
    init : function(){
        var self = this;
        
        $(document).on('click', '[href="#download-pdf"]', function(e){
            e.preventDefault();
            var filename     = $(this).data('filename');
            var sheetWidth   = 1944; 
            var $clonedBody  = self.$html.find('body')[0];

            mainHandler.carousel();
            var $body = self.$html.find('body')[0];            
            var $clonedBody = $($body).clone();
            $clonedBody.addClass('print-mode');
            $clonedBody.insertAfter($body);
            $clonedBody = $clonedBody[0];

            var sheetHeight = Math.max($clonedBody.scrollHeight, $clonedBody.offsetHeight) + 80;//$($body).outerHeight();//Math.max($body.scrollHeight, $body.offsetHeight) + addonHeight;
            if (!filename) {
                filename = 'untitled.pdf'
            }
            
            var opt = {
                margin:       1,
                filename:     filename,
                image:        { type: 'jpeg', quality: 1 },
                html2canvas:  { //scale: 2, 
                                dpi: 720, letterRendering: true, useCORS: true }, 
                jsPDF:        { unit: 'px', format: [sheetHeight, sheetWidth], orientation: 'portrait' },
            };
            html2pdf().from($clonedBody).set(opt).save().then(function(){
                $clonedBody.remove();
                mainHandler.carousel();
            });
        });
    }
}
